import {AxiosPromise} from "axios";
import {CONSTANT_CONFIG} from "../../constants";
import { HttpService } from "../../services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.AUTH_SERVER_PREFIX}/oauth`
const endpoints = {
    loadAuthState: () => `${RESOURCE_ENDPOINT}/load-global-state`,
    login: () => `${RESOURCE_ENDPOINT}/admin-login`,
    register: () => `${RESOURCE_ENDPOINT}/register`,
    verifyUserEmail: () => `${RESOURCE_ENDPOINT}/verify-email`,
    forgotPassword: () => `${RESOURCE_ENDPOINT}/forgot-password`,
    resetPassword: () => `${RESOURCE_ENDPOINT}/reset-password`,
    changePassword: () => `${RESOURCE_ENDPOINT}/change-password`,
    logout: () => `${RESOURCE_ENDPOINT}/logout`,
    refreshToken: () => `${RESOURCE_ENDPOINT}/token/refresh`,
    invitePeople: () => `${RESOURCE_ENDPOINT}/invite-people`,
}

export default class OauthApi {
    public loadAuthState = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.loadAuthState();
        return HttpService.post(url, payload, params, headers);
    }

    public login = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.login();
        return HttpService.post(url, payload, params, headers);
    }

    public register = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.register();
        return HttpService.post(url, payload, params, headers);
    }

    public verifyUserEmail = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.verifyUserEmail();
        return HttpService.post(url, payload, params, headers);
    }

    public forgotPassword = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.forgotPassword();
        return HttpService.post(url, payload, params, headers);
    }

    public resetPassword = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.resetPassword();
        return HttpService.post(url, payload, params, headers);
    }

    public changePassword = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.changePassword();
        return HttpService.post(url, payload, params, headers);
    }

    public logout = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.logout();
        return HttpService.post(url, payload, params, headers);
    }

    public refreshToken = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.refreshToken();
        return HttpService.post(url, payload, params, headers);
    }

    public invitePeople = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.invitePeople();
        return HttpService.post(url, payload, params, headers);
    }
}